<template>
  <div class="page-wrapper">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top">
      <div class="form-wrapper">
        <el-form-item label="课程标题" prop="name">
          <el-input
            class="w"
            maxlength="30"
            v-model="ruleForm.name"
            placeholder="请输入课程标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="课程简介" prop="brief">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8}"
            class="w"
            maxlength="200"
            v-model="ruleForm.brief"
            placeholder="请输入课程简介"
          ></el-input>
        </el-form-item>
        <el-form-item label="上课时间" prop="duringTime">
            <el-date-picker
              v-model="ruleForm.duringTime"
              type="datetimerange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
            >
            </el-date-picker>
        </el-form-item>

        <el-form-item label="上课地点" prop="region" required>
          <el-cascader :options="regionData" clearable
            :props="{
              value: 'id',
              label: 'name',
              children: 'child'
            }"
            @change="selectRegion"
            v-model="ruleForm.region"
          ></el-cascader>
          <el-input
            class="w"
            v-model="ruleForm.address"
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>

        <el-form-item label="课程价格" prop="price">
          <el-input
            class="w"
            v-model="ruleForm.price"
            type="number"
            step="0.01"
            min="0" max="10000"
            placeholder="请输入课程价格"
          >
            <template slot="prepend">￥</template>
          </el-input>
        </el-form-item>

        <el-form-item label="课程来源" prop="source">
          <el-select class="w" v-model="ruleForm.source" placeholder="请选择课程来源">
            <el-option label="自营课程" :value="1"></el-option>
            <el-option label="合作机构课程" :value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="课程状态" prop="state">
          <el-radio-group v-model="ruleForm.state">
            <el-radio :label="1">在售</el-radio>
            <el-radio :label="2">下架</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item label="课程详情图" prop="fileList" required>
          <el-upload
            class="cg-img-uploader"
            :action="uploadFileApi"
            name="files"
            :data="uploadData"
            list-type="picture-card"
            :on-success="handleImgSuccess"
            :on-error="handleImgError"
            :before-upload="beforeImgUpload"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            accept="image/*"
            :file-list="ruleForm.fileList"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </div>
    </el-form>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <div class="bottom-btns-wrap">
      <el-button class="btn-large" type="primary" @click="submitForm">确认修改</el-button>
    </div>
  </div>
</template>

<script>
import { regionData } from '@/common/region-data.js'
import { utils } from '@/common/common.js'
import { request, api } from '@/common/request_course.js'
import { buildThumborUrl } from '@/common/tool.js'
import { Loading } from 'element-ui';
export default {
  computed: {
    adminId() {
      return utils.getAdminId()
    },
  },
  inject: ["reload"],
  data() {
    var validateAddress = (rule, value, callback) => {
      if (!this.ruleForm.region || this.ruleForm.region.length == 0) {
        callback(new Error('请选择地区'));
      } else if (this.ruleForm.address.trim() == '') {
        callback(new Error('请填写详细地址'));
      } else {
        callback();
      }
    };
    var validateFileList =  (rule, value, callback) => {
      if (!this.ruleForm.fileList || this.ruleForm.fileList.length == 0) {
        callback(new Error('请上传课程详情图'));
      } else {
        callback();
      }
    };
    return {
      regionData,
      ruleForm: {
        name: '', // 名称
        brief: '', // 简介
        duringTime: '', // 时间范围
        region: [], // 区域
        address: '', // 详细地址
        price: '', // 价格
        source: '', // 课程来源
        state: '', // 课程状态
        fileList: [], // 文件列表
      },
      rules: {
        name: [
          { required: true, message: "请输入课程名称", trigger: "change" }
        ],
        duringTime: [
          { required: true, message: "请输入课程简介", trigger: "change" }
        ],
        region: [
          { validator: validateAddress, trigger: "change" }
        ],
        price: [
          { required: true, message: "请输入课程价格", trigger: "change" }
        ],
        source: [
          { required: true, message: "请选择课程来源", trigger: "change" }
        ],
        state: [
          { required: true, message: "请选择课程状态", trigger: "change" }
        ],
        fileList: [
          { validator: validateFileList, trigger: "change" }
        ]
      },
      // 上传图片api
      uploadFileApi: api.baseUrl + '/minio-oss/fileUpload',
      uploadData: {
        bucketName: 'fzzht-steamer-course-image',
      },
      dialogImageUrl: '',
      dialogVisible: false,
    };
  },
  watch: {},
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      let loadingInstance = Loading.service({
        text: '载入数据...'
      });
       request({
        url: api.baseUrl + "/course/detail",
        method: "get",
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        params: {
          courseId: this.$route.query.id
        }
      })
      .then((res) => {
        console.log(res);
        loadingInstance.close()
        if (res.erroyCode == 200) {
          let data = res.data
          this.ruleForm.name = data.name
          this.ruleForm.brief = data.brief
          this.ruleForm.duringTime = [data.startTime.slice(0, 16), data.endTime.slice(0, 16)]
          this.ruleForm.region = [''+ data.provinceId, ''+ data.cityId, ''+ data.districtId]
          this.ruleForm.address = data.address
          this.ruleForm.price = data.price
          this.ruleForm.source = data.source
          this.ruleForm.state = data.state
          this.ruleForm.fileList = data.detailPicture.map(item => {
            return {
              name: item,
              url: buildThumborUrl(item),
              dataUrl: item
            }
          })
          console.log(this.ruleForm.fileList)
        } else {
          this.$message.error(res.errorMsg || "网络错误");
        }
      })
      .catch((err) => {
        loadingInstance.close()
        console.log(err);
      })
    },
    selectRegion(value) {
      console.log(value)
    },
    switchRegionIdToName(value) {
      let proItem = this.regionData.filter(item => item.id == value[0])[0]
      let provinceName = proItem.name
      let cityItem = proItem.child.filter(item => item.id == value[1])[0]
      let cityName = cityItem.name
      let districtItem = cityItem.child.filter(item => item.id == value[2])[0]
      let districtName = districtItem.name
      console.log(provinceName, cityName, districtName)
      return [provinceName, cityName, districtName]
    },
    // 提交新增新闻表单
    submitForm() {
      console.log(this.ruleForm)
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let name = this.ruleForm.name.trim()
          let brief = this.ruleForm.brief.trim()
          let startTime = this.ruleForm.duringTime[0] + ':00'
          let endTime = this.ruleForm.duringTime[1] + ':00'
          let provinceId = this.ruleForm.region[0]
          let cityId = this.ruleForm.region[1]
          let districtId = this.ruleForm.region[2]
          let regionName = this.switchRegionIdToName(this.ruleForm.region)
          let provinceName = regionName[0]
          let cityName = regionName[1]
          let districtName = regionName[2]
          let address = this.ruleForm.address
          let price = parseFloat(this.ruleForm.price).toFixed(2)
          let source = this.ruleForm.source
          let state = this.ruleForm.state
          let detailPicture = this.ruleForm.fileList.map(item => item.dataUrl || item.response.data[0])
          let params = {
            name,
            brief,
            startTime,
            endTime,
            provinceId,
            cityId,
            districtId,
            provinceName,
            cityName,
            districtName,
            address,
            price,
            source,
            state,
            detailPicture,
            id: this.$route.query.id,
            updateBy: this.adminId,
          }
          console.log(params)
          let loadingInstance = Loading.service({
            text: '正在提交...'
          });
          request({
            url: api.baseUrl + "/course/update",
            method: "post",
            data: params
          })
          .then((res) => {
            console.log(res);
            if (res.erroyCode == 200) {
              this.$message.success('修改成功')
              this.$router.go(-1)
            } else {
              this.$message.error(res.errorMsg || "网络错误");
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            loadingInstance.close();
          });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleImgSuccess(res, file, fileList) {
      console.log(res, file, fileList)
      if (res.erroyCode == 200) {
        this.ruleForm.fileList = fileList
        this.$refs.ruleForm.validateField('fileList')
      } else {
        this.$message.error(res.errorMsg || '上传失败')
      }
    },
    handleImgError(err){
      console.log(err);
      this.$message.error('上传失败')
    },
    beforeImgUpload(file) {
      console.log(file)
      console.log(this.ruleForm.fileList)
      if (this.ruleForm.fileList.length >= 5) {
        this.$message.error('最多上传5张哟!');
        return false
      }
      const isRequiredImg = /^image\/[jpg|jpeg|png]/.test(file.type)
      const isLimit = file.size / 1024 / 1024 < 10
      if (!isRequiredImg) {
        this.$message.error('请上传.jpg或.png格式的图片!');
      }
      if (!isLimit) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return isRequiredImg && isLimit;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.fileList = fileList
      this.$refs.ruleForm.validateField('fileList')
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  padding: 0 16px 16px;
  background: #fff;
  .form-wrapper {
    width: 980px;
    box-sizing: border-box;
    padding: 20px;
    .w {width: 600px;}
  }
  .bottom-btns-wrap {
    width: 980px;
    box-sizing: border-box;
    padding-bottom: 20px;
    text-align: center;
    .btn-large {
      padding: 16px 120px;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/pages/course/edit.vue